// extracted by mini-css-extract-plugin
export default {"about__btn":"action-button_about__btn__7coLU"};